import { useEffect, useState } from 'react';
import { CheckCircle, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';

const icons = {
  success: CheckCircle,
  error: AlertCircle,
  warning: AlertTriangle,
  info: Info
};

const bgColors = {
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3b82f6'
};

export default function Toast({ id, message, type = 'info', onClose, duration = 3000 }) {
  const Icon = icons[type];
  const bgColor = bgColors[type];
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const exitTimer = setTimeout(() => {
        setExiting(true);
      }, duration - 300);
      const removeTimer = setTimeout(() => {
        onClose(id);
      }, duration);
      return () => {
        clearTimeout(exitTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [id, duration, onClose]);

  const handleClose = () => {
    setExiting(true);
    setTimeout(() => onClose(id), 200);
  };

  return (
    <div
      className={`flex items-center gap-2.5 pl-3 pr-2 py-2.5 rounded-2xl shadow-xl backdrop-blur-sm transition-all duration-200 ${
        exiting ? 'opacity-0 translate-y-2 scale-95' : 'opacity-100 translate-y-0 scale-100'
      }`}
      style={{
        backgroundColor: `${bgColor}f0`,
        boxShadow: `0 8px 32px ${bgColor}40, 0 2px 8px rgba(0,0,0,0.1)`
      }}
      role="alert"
    >
      <Icon className="w-[18px] h-[18px] text-white flex-shrink-0" />
      <p className="flex-1 text-[13px] font-semibold text-white leading-tight">{message}</p>
      <button
        onClick={handleClose}
        className="flex-shrink-0 p-1 rounded-full hover:bg-white/20 active:bg-white/30 transition-colors"
      >
        <X className="w-3.5 h-3.5 text-white/80" />
      </button>
    </div>
  );
}
